const Routes = Object.freeze({
  DASHBOARD: '/',
  PRACTICE_AREA: '/practice-area',
  PRACTICE_SET: '/practice-sets/:practiceSetId',
  PRACTICE_SET_RESULTS: '/practice-sets/:practiceSetId/results',
  FULL_PAST_PAPERS: '/full-past-papers',
  PAPER: '/papers/:paperId',
  PAPER_ATTEMPT: '/paper-attempts/:attemptId',
  ATTEMPT_RESULTS: '/paper-attempts/:attemptId/results',
  DOWNLOAD_PAST_PAPERS: '/download-past-papers',
  PROGRESS_TRACKER: '/progress-tracker',
  ACCOUNT_SETTINGS: '/account-settings',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CONFIRM_EMAIL: '/confirm-email',
  ONBOARDING: '/onboarding',
  STUDENT_ONBOARDING: '/student-onboarding',
  PAYMENT_SELECT: '/payment-select',
  DATA_TABLE: '/data-table',
  INPUTS: '/inputs',
  SANDBOX: '/sandbox',
  EMAIL_TEMPLATE: '/email-template',
  PASSWORD_CHANGED_CONFIRMATION: '/password-changed',
  EMAIL_CHANGED_CONFIRMATION: '/email-changed',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  ADMIN_PAST_PAPERS: '/admin/past-papers',
  ADMIN_UPLOAD_PAST_PAPER: '/admin/past-papers/upload',
  ADMIN_EDIT_PAST_PAPER: '/admin/past-papers/:paperId',
  ADMIN_GRADING_PROMPTS: '/admin/grading-prompts',
  ADMIN_EDIT_GRADING_PROMPT: '/admin/grading-prompts/:promptId',
  ADMIN_PRACTICE_QUESTIONS: '/admin/practice-questions',
  ADMIN_EDIT_PRACTICE_QUESTION: '/admin/practice-questions/:questionId',
  ADMIN_CATEGORIES: '/admin/categories',
  ADMIN_EDIT_CATEGORY: '/admin/categories/:categoryId',
  ADMIN_QUESTION_GENERATION_PROMPTS: '/admin/question-generation-prompts',
} as const);

export default Routes;

export type AvailableRoutes = (typeof Routes)[keyof typeof Routes];
